import React from 'react';
import TableSkeleton from 'components/TableSkeleton';

const OutstandingRecapsSkeleton = () => {
  return (
    <div className="container mx-auto mt-8 max-sm:px-4">
      <h5 className="typography-product-heading-compact-desktop max-sm:typography-product-subheading mb-ds-xl max-sm:mb-ds-md">
        Outstanding Recaps
      </h5>
      <TableSkeleton layout="table" rows={3} />
    </div>
  );
};

export default OutstandingRecapsSkeleton;
